/**
 * reviewerJoinPaths.js — public invite paths for a specialty knowledge reviewer.
 * Shaped by prompt 35; MKT-10.
 * Invariants: alias only; the claim callable and the `code` query parameter
 * stay the same. New links use the neutral path. /specialty-kb/join stays for
 * invites already sent. Public copy does not use this module to name SpecialtyKB.
 * Related: ReviewerInviteJoinPage.jsx, SkbReviewerInvitePanel.jsx, AppRoutes.jsx
 */

export const SPECIALTY_REVIEWER_JOIN_PATH = "/specialty-reviewer/join";
export const SPECIALTY_KB_JOIN_PATH = "/specialty-kb/join";

export function reviewerJoinUrl(origin, code) {
  const base = String(origin || "").replace(/\/$/, "");
  return `${base}${SPECIALTY_REVIEWER_JOIN_PATH}?code=${encodeURIComponent(code)}`;
}
